function visiblePageItems(currentPage, totalPages) {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const items = [1];
  const rangeStart = Math.max(2, currentPage - 1);
  const rangeEnd = Math.min(totalPages - 1, currentPage + 1);

  if (rangeStart > 2) items.push("start-ellipsis");
  for (let page = rangeStart; page <= rangeEnd; page += 1) items.push(page);
  if (rangeEnd < totalPages - 1) items.push("end-ellipsis");
  items.push(totalPages);
  return items;
}


export default function PaginationControls({
  page,
  pageSize,
  totalItems,
  totalPages,
  onPageChange,
  testIdPrefix = "pagination",
}) {
  if (totalItems <= pageSize) return null;

  const firstItem = (page - 1) * pageSize + 1;
  const lastItem = Math.min(page * pageSize, totalItems);

  return (
    <nav
      className="mt-4 flex flex-col sm:flex-row items-center justify-between gap-3 border border-zinc-200 bg-white px-3 py-3"
      aria-label="Navigasi halaman"
      data-testid={`${testIdPrefix}-controls`}
    >
      <div className="text-xs font-mono text-zinc-500">
        Menampilkan {firstItem}-{lastItem} dari {totalItems} data
      </div>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          data-testid={`${testIdPrefix}-previous`}
          className="border border-zinc-300 px-3 py-1.5 text-xs font-semibold text-zinc-700 hover:bg-zinc-50 disabled:cursor-not-allowed disabled:opacity-40"
        >
          Previous
        </button>

        {visiblePageItems(page, totalPages).map((item) => (
          typeof item === "number" ? (
            <button
              type="button"
              key={item}
              onClick={() => onPageChange(item)}
              aria-current={item === page ? "page" : undefined}
              data-testid={`${testIdPrefix}-page-${item}`}
              className={`min-w-8 border px-2 py-1.5 text-xs font-mono font-bold ${
                item === page
                  ? "border-[#002FA7] bg-[#002FA7] text-white"
                  : "border-zinc-300 bg-white text-zinc-700 hover:bg-zinc-50"
              }`}
            >
              {item}
            </button>
          ) : (
            <span key={item} className="px-1 text-xs text-zinc-400" aria-hidden="true">...</span>
          )
        ))}

        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          data-testid={`${testIdPrefix}-next`}
          className="border border-zinc-300 px-3 py-1.5 text-xs font-semibold text-zinc-700 hover:bg-zinc-50 disabled:cursor-not-allowed disabled:opacity-40"
        >
          Next
        </button>
      </div>
    </nav>
  );
}
